export default __webpack_public_path__ + "static/media/toucanmaison.a33c27a6.png";